var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M2.727 2.961l4.062-.937a.943.943 0 011.074.543l1.875 4.375a.933.933 0 01-.27 1.093L7.101 9.973a14.485 14.485 0 006.922 6.922l1.938-2.367a.934.934 0 011.093-.27l4.376 1.875a.949.949 0 01.547 1.078l-.937 4.062a.938.938 0 01-.914.727C10.12 22 2 13.895 2 3.875c0-.437.3-.816.727-.914z"
  }))));
}

export default SvgPhone;